import type { ComponentProps } from 'react';
import gmailLogo from './gmail.svg';

export const IconGmail = (props: ComponentProps<'img'>) => (
  <img src={gmailLogo} alt="Gmail" {...props} />
);
